import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSetUploadedDocumentUrl = () => {
    const send = useGenericSend();

    return useCallback(
        async (request: Types.ISetUploadedDocumentUrlRequestData): Promise<TServerSendResponse> => {
            const { data } = await send<Types.ISetUploadedDocumentUrlRequestData, TServerSendResponse>({
                ID: 35802,
                description: 'Set uploaded document url request',
                responses: [35803, 35804],
                errorLevel: 1,
                ...request
            });

            return data;
        }, [
            send
        ]);
};
